export enum PaymentStatus {
  Cancelled = 'Cancelled',
  AwaitingCashOut = 'Awaiting-cash-out',
  WaitingForApprove = 'Awaiting-approval',
  AwaitingSignUp = 'Awaiting-sign-up',
  Mailed = 'Mailed',
  OFACRestricted = 'OFAC Restricted',
  Failed = 'Failed',
  Settled = 'Settled',
  InTransit = 'In-transit',
  PreparingToMail = 'Preparing to mail',
  MailingSoon = 'Mailing Soon',
  PreparingToMailAgain = 'Resubmitted: Preparing to mail again',
  Cashed = 'Cashed',
}
